export default __webpack_public_path__ + "static/media/4.2ffc3364.mp3";